import React, { useMemo } from "react";
import styled from "styled-components";
import { FlexContainer, TextLabel, Button, StandardModal } from "src/components";
import CheckIcon from "src/img/check@2x.png";
import { formatProratedPeriod } from "./pricingUtils";

export const Card = styled.div`
    background-color: #EDEDED;
    width: calc(100% + 40px); 
    max-width: calc(26.375rem + 40px); 
    margin-left: -20px; 
    margin-right: -20px; 
    min-height: auto;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 40px 20px;
    box-sizing: border-box;
    text-align: center;
`;

export const StyledButton = styled(Button)`
    width: 185px;
    height: 38px;
    background: #8E4EB4;
    border-radius: 7px;
    color: #fff;
    font-weight: 500;
    font-size: 15px;
    margin-top: 20px;
`;

export default function EmailUpgradeSuccessModal({ company, plan, statistics, onClose, proratePricing }) {

    const prorated = useMemo(() => {
        if (!statistics?.proratedPeriod) return null;
        return formatProratedPeriod(statistics.proratedPeriod);
    }, [statistics]);

    const currentProrated = useMemo(() => {
        if (!proratePricing || !plan) return null;
        return proratePricing.find(p => p.addonId === plan.uuid) || null;
    }, [proratePricing, plan]);

    return (
        <StandardModal
            open={true}
            onClose={onClose}
            title="Email Pro Successfully Added"
            description="Your Email Pro upgrade has been activated and is now part of your Me Business subscription. You can start sending higher-volume email campaigns immediately."
            widthMode="large"
        >
                <FlexContainer direction="column" alignItems="center" gap="20px">
                    <FlexContainer direction="column" flex="1" width="100%" alignItems="center" gap="30px"
                        style={{
                            background: "#FFF",
                            borderRadius: "12px",
                            padding: "1.5em 2.5rem",
                            boxSizing: "border-box",
                            boxShadow: "0px 3px 6px #00000029",
                            minHeight: "580px",
                        }}
                    >
                        <FlexContainer direction="column" alignItems="center" gap="20px" marginTop="20px">
                            {/* Header */}
                            <FlexContainer alignItems="center" gap="12px" direction="row">
                                <img src={CheckIcon} width="60px" height="60px" />
                                <TextLabel size="32px" weight="700" color="#11141A" align="center">
                                    Upgrade Complete!
                                </TextLabel>
                            </FlexContainer>

                            {/* Business Name */}
                            <FlexContainer direction="column" alignItems="center" gap="4px">
                                <TextLabel weight="600">Business Name:</TextLabel>
                                <TextLabel>{company || "N/A"}</TextLabel>
                            </FlexContainer>

                            {/* Upgrade Name */}
                            <FlexContainer direction="column" alignItems="center" gap="4px">
                                <TextLabel weight="600">Upgrade:</TextLabel>
                                <TextLabel>{plan?.title || "Email Pro"}</TextLabel>
                            </FlexContainer>

                            {/* Billing Type */}
                            <FlexContainer direction="column" alignItems="center" gap="4px">
                                <TextLabel weight="600">Billing Type:</TextLabel>
                                <TextLabel>Prorated Upgrade</TextLabel>
                            </FlexContainer>

                            {/* Coverage Period */}
                            <FlexContainer direction="column" alignItems="center" gap="4px">
                                <TextLabel weight="600">Coverage Period:</TextLabel>
                                <TextLabel>{prorated?.display} of your current subscription</TextLabel>
                            </FlexContainer>

                            {/* Amount Paid Today */}
                            <FlexContainer direction="column" alignItems="center" gap="4px">
                                <TextLabel weight="600">Amount Paid Today:</TextLabel>
                                <TextLabel>AUD ${currentProrated?.total?.toFixed(2)}</TextLabel>
                            </FlexContainer>

                            <StyledButton onClick={onClose}>Go to Email Campaigns</StyledButton>
                        </FlexContainer>
                    </FlexContainer>
                </FlexContainer>
        </StandardModal>
    );
}
